export const multipleMissionsRatings = [
  {
    distribution: 'Poor (Low 10%)',
    min: 0,
    max: 49,
    suggestion: 'Significant Improvement Needed',
  },
  {
    distribution: 'Below average (20%)',
    min: 50,
    max: 69,
    suggestion: 'Improvement Necessary',
  },
  {
    distribution: 'Below average (20%)',
    min: 70,
    max: 79,
    suggestion: 'Moderate Improvement Required',
  },
  {
    distribution: 'Average (40% of the peers)',
    min: 80,
    max: 89,
    suggestion: 'Approaching Expectations',
  },
  {
    distribution: 'Average (40% of the peers)',
    min: 90,
    max: 99,
    suggestion: 'Nearly Meets Expectations',
  },
  {
    distribution: 'Average (40% of the peers)',
    min: 100,
    max: 109,
    suggestion: 'Fully Meets Expectations',
  },
  {
    distribution: 'Above average (20% of the peers)',
    min: 111,
    max: 119,
    suggestion: 'Surpasses Expectations',
  },
  {
    distribution: 'Above average (20% of the peers)',
    min: 120,
    max: 129,
    suggestion: 'Greatly Exceeds Expectations',
  },
  {
    distribution: 'Outstanding (Top 10%)',
    min: 130,
    suggestion: 'Far Exceeds Expectations',
  },
];
